import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataType2Preguntas } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

export const interpret = (
    cards: AllCardsType[],
    data: DataType2Preguntas,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    let consult = `Interpreta las dos tiradas de cartas que realizaste para ${
        data.consultante.name
    } que necesita saber en la primer tirada: ${data.consulta1}, en esta tirada salieron las siguientes cartas: ${formatCardLabel(cards[0])}, ${formatCardLabel(cards[1])}, ${formatCardLabel(cards[2])}, ${formatCardLabel(cards[3])} y ${formatCardLabel(cards[4])}; y para la segunda tirada la consulta es: ${data.consulta2} y las cartas que salieron son: ${formatCardLabel(cards[5])}, ${formatCardLabel(cards[6])}, ${formatCardLabel(cards[7])}, ${formatCardLabel(cards[8])} y ${formatCardLabel(cards[9])}. Decide tú como tarotista experta que eres, cual es el mejor tipo de lectura que puedes hacer para estas dos tiradas de cartas en base a lo que el consultante necesita saber en cada una de ellas. No enumeres carta por carta, sino más bien, haz un relato mencionandolas dentro del relato. Ten en cuenta el signo zodiacal del consultante: ${
        data.consultante.zodiac
    }. Dirígete directamente al consultante.`

    let info = {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: 'Consulta uno: ' + data.consulta1 + '. Consulta dos:  ' + data.consulta2,
        cards,
        type,
    }

    return info
}
